import { styled } from "@mui/material";
import { COLORS } from "constants/layout";
import { StyledRouterA } from "../Text";
import { useIntl } from "react-intl";

interface VisitCompanyButtonProps {
  path: string;
  shorter?: boolean;
  className?: string;
}

const VisitCompanyButton = ({
  path,
  shorter,
  className,
}: VisitCompanyButtonProps) => {
  const t = useIntl();

  return (
    <StyledLink
      to={path}
      className={`visit-company-btn ${className || ''}`}
      sx={{
        padding: {
          xs: "2px 6px",
          md: "6px 16px",
        }
      }}
    >
      {t.formatMessage({ id: "visit_company" })}
    </StyledLink>
  );
};

const StyledLink = styled(StyledRouterA)(({ theme }) => ({
  border: `1px solid ${COLORS.green[600]}`,
  color: `${COLORS.green[600]} !important`,
  backgroundColor: "#fff",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "8px",
  textDecoration: "none",
  fontWeight: 500,
  fontSize: "0.875rem",
  lineHeight: 1.75,
  cursor: "pointer",
  transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  
  "&:hover": {
    backgroundColor: "rgba(0, 123, 85, 0.04)",
    textDecoration: "none",
  },

  [theme.breakpoints.down("md")]: {
    fontSize: 12,
    padding: 8,
  },
}));

export default VisitCompanyButton;
